import { render, staticRenderFns } from "./ParentPage.vue?vue&type=template&id=69b12eb9&"
import script from "./ParentPage.vue?vue&type=script&lang=ts&"
export * from "./ParentPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports